import {
    FETCH_REPORT_CONFIG,
    FETCH_REPORT_CONFIG_FAILURE,
    FETCH_REPORT_CONFIG_SUCCESS,
    UPDATE_REPORT_CONFIG, UPDATE_REPORT_CONFIG_FAILURE, UPDATE_REPORT_CONFIG_SUCCESS
} from "../actions/report";

const INITIAL_STATE = {
    error: null,
    loading: false,
    saving: false,
    saved: false
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {
        case FETCH_REPORT_CONFIG:
            return { ...state, reportConfig: null, saved: false, loaded: false, loading: true, error: null};
        case FETCH_REPORT_CONFIG_SUCCESS:
            return { ...state, reportConfig: action.payload, loaded: true, loading: false, error: null};
        case FETCH_REPORT_CONFIG_FAILURE:
            error = action.payload || {message: action.payload.message};
            return { ...state,  reportConfig: null, loaded: false, loading: false, error: error};
        case UPDATE_REPORT_CONFIG:
            return { ...state, saving: true, saved: false};
        case UPDATE_REPORT_CONFIG_SUCCESS:
            return { ...state, saving: false, saved: true, reportConfig: action.payload, error: null};
        case UPDATE_REPORT_CONFIG_FAILURE:
            error = action.payload || {message: action.payload.message};
            return { ...state, saving: false,  reportConfig: null, loaded: false, loading: false, error: error};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/report.js